import {ValueObject} from '@s-ui/domain'

export default class PriceValueObject extends ValueObject {
  /**
   * @param {Object} price
   * @param {Number} price.value
   * @param {Number} price.amountLabelValue
   * @param {String} price.currency
   * */

  static validate({InvalidPriceErrorFactory, ...rest}) {
    /**
     * @return {Bool}
     * Checks if one of the parameters defined in the factory has a falsy value.
     * */
    const hasError = Object.values(rest).some(value => !value)

    if (hasError) throw InvalidPriceErrorFactory()
  }

  getPrice = () => {
    return {
      value: this._value,
      amountLabelValue: this._amountLabelValue,
      currency: this._currency
    }
  }
}
